export default "__VITE_ASSET__CgFcGNzW__"